module.exports = __webpack_public_path__ + "static/news-4-cee341eeac158c6121706ec6e54a8fcb.png";